import React from 'react';
import { useAppState } from '../src/contexts/AppStateContext';

const EventSwitcher = () => {
  const { events, currentEvent, switchEvent, loading, currentOrganization } = useAppState();

  if (!currentOrganization) {
    return <div className="text-sm text-gray-500">Please select an organization first</div>;
  }

  if (loading) {
    return <div className="text-sm text-gray-500">Loading events...</div>;
  }

  if (!events || events.length === 0) {
    return <div className="text-sm text-gray-500">No events available for this organization</div>;
  }

  return (
    <div className="mb-4">
      <label htmlFor="event-select" className="block text-sm font-medium text-gray-700 mb-1">
        Event:
      </label>
      <select
        id="event-select"
        value={currentEvent?.id || ''}
        onChange={(e) => switchEvent(e.target.value)}
        disabled={loading}
        className="block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
      >
        {events.map(event => (
          <option key={event.id} value={event.id}>
            {event.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default EventSwitcher;